import React from 'react';

export function Avatar({ src, label, size = 40, className = '' }) {
  const style = { width: size, height: size, fontSize: Math.max(10, size * 0.35) };
  return (
    <span className={`ds-avatar ${className}`.trim()} style={style}>
      {src ? <img src={src} alt="" className="ds-avatar__img" /> : <span>{label || '?'}</span>}
    </span>
  );
}

export default Avatar;
